var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 260,
    height: 150.968,
    viewBox: "0 0 260 150.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3275",
    "data-name": "Rectangle 3275",
    width: 260,
    height: 150.968,
    transform: "translate(-0.333 0.333)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(0.333 -0.333)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sorry",
    transform: "translate(62.274 0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG",
    transform: "translate(4.85 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    "data-name": "Path 3636",
    d: "M137.957,83.794a32.432,32.432,0,0,0-6.082-8.31,85.207,85.207,0,0,0-7.5-6.274c-2.371-1.94-4.6-4.167-4.933-7.376-.407-3.52.838-7.064,1.509-10.489A26.885,26.885,0,0,0,116.836,30.8a37.274,37.274,0,0,0-16.26-12.979c-6.3-2.73-13.458-3.688-19.325-7.352-3.113-1.94-5.46-4.837-8.477-6.921A20.868,20.868,0,0,0,62.98.171,34.531,34.531,0,0,0,42.7,4.721a20.77,20.77,0,0,0-7.184,7.16c-1.628,2.61-2.85,5.436-4.334,8.142a17.7,17.7,0,0,1-5.628,6.609c-2.61,1.724-5.508,2.9-8.142,4.55A16.552,16.552,0,0,0,10.8,38.438,20.707,20.707,0,0,0,9.243,48.28c.575,7.615,4.574,14.2,6.537,21.432a21.076,21.076,0,0,1,.647,9.914c-.814,3.616-3.472,6.3-4.694,9.746a17.169,17.169,0,0,0-.91,6.13c1.892-.5,4.119,1.1,5,1.82,3.64,2.921,5.627,7.735,6.873,11.925-.455-1.437-.383-2.945-.742-4.406a25.658,25.658,0,0,0-1.916-5.1c-.814-1.676-2.514-4.095-2.993-5.963a2.042,2.042,0,0,1,1.173-2.538c1.916-.359,2.993.934,3.712,1.6,2.155,2.012,3.377,4.478,4.789,7.016a50.482,50.482,0,0,1,2.778,6.945l.024.048a2.144,2.144,0,0,1,.814-.91,1.5,1.5,0,0,1,1.94.192l.216-.359A53.09,53.09,0,0,1,37.4,93.8a121.07,121.07,0,0,1,9.483-14.248c.527-2.586.838-7.615,4.478-9.651.168.12.335.239.527.359l-.048-.12a242.739,242.739,0,0,1-5.053-24.593c-1.149.1-6.2,1.94-7.687,2.371-1.748.479-6.657,1.652-9,2.2s4.765-11.087,6.8-14.033c3.544-5.125,7.639-10.656,12.476-14.608l1.006-.862a11.573,11.573,0,0,1-4.071-1.293c-.718-.359-.383-1.221.335-1.269,5.34-.479,8.477-4.334,13.745-5.244a17.573,17.573,0,0,1,8.884,1.006,6.573,6.573,0,0,1,4.334,4.526c5.22-.287,6.945,7.567,7.543,11.518.12.742.216,1.509.287,2.251h0a10.266,10.266,0,0,1,1.221-.359c3.424-.838,7.807.311,6.9,4.646-.742,3.544-4.6,4.6-8.046,4.981-.144,2.275-.383,4.55-.671,6.825a.777.777,0,0,1-.886.647h-.024c.168.79.335,1.6.479,2.395.335,1.892,1.557,9.627,1.557,9.627l.048.192a.523.523,0,0,1,.12-.072c.886-.455,2.467,1.341,2.85,1.868A19.282,19.282,0,0,1,88.363,71.7c3.424.287,9.6,2.826,11.973,4.31a70.971,70.971,0,0,1,15.973,13.195A94.212,94.212,0,0,1,131.2,110.255c.072.12.12.263.192.383a28.9,28.9,0,0,0,6.394-7.567A20.573,20.573,0,0,0,137.957,83.794Z",
    transform: "translate(-9.167 -0.01)",
    fill: "#f4f6f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    "data-name": "Path 3637",
    d: "M37.89,182.53a12.558,12.558,0,0,0,1.916-6.394c.024-1.485-.216-4.861,1.413-5.771,1.988-1.126,2.969,1.676,3.424,2.969,1.006,2.993.455,7.016.1,10.082-.144,1.221-1.533,5.723-1.006,6.322",
    transform: "translate(-15.196 -64.43)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    "data-name": "Path 3638",
    d: "M88.155,207.611s-3.712-2.634-5.029-3.64a43.88,43.88,0,0,1-3.831-3.5c-2.514-2.419-2.73-5.8-2.874-9.148a48.134,48.134,0,0,1,.814-12.716,61.59,61.59,0,0,1,2.251-8.214c.79-1.748,1.149-3.592,3.4-4.167,4.119-1.03.407,7.424,1.173,10.153",
    transform: "translate(-29.756 -62.931)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    d: "M86.5,173.26c2.059-2.443,3.616-5.316,5.8-7.711,2.107-2.3,4.263-4.837,6.561-6.992a34.141,34.141,0,0,1,5.939-4.646c1.1-.647,3.808-1.868,3.832.982.048,2.49-4.526,5.388-6.705,7.735",
    transform: "translate(-33.604 -57.986)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M104.38,168.026c4.167-4.047,7.807-8.118,12.907-11.039,1.1-.623,4-1.82,4.67.024.694,1.892-2.035,3.353-3.233,4.239-1.173.886-5.484,4.6-6.537,5.6",
    transform: "translate(-40.378 -59.099)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M113.631,171.621c3.9-2.754,6.274-5.077,10.561-6.561,1.58-.551,3.3-.718,3.353,1.293.072,2.275-2.275,3.592-4.071,4.646-1.676.982-3.951,2.754-5.651,3.736",
    transform: "translate(-43.881 -62.382)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    "data-name": "Path 3642",
    d: "M115.286,180.255a26.044,26.044,0,0,1,7.184-3.424c1.126-.287,4.957-1.533,4.382,1.221-.192.934-1.341,1.844-2.012,2.443-1.2,1.078-2.514,2.155-3.64,3.329a45.217,45.217,0,0,0-3.137,3.281c-.814,1.03-1.628,2.012-2.419,3.065-1.628,2.131-2.61,4.67-3.9,6.992",
    transform: "translate(-43.166 -66.777)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    "data-name": "Path 3643",
    d: "M26.522,162.35a50.48,50.48,0,0,0-2.778-6.945c-1.413-2.562-2.658-5.029-4.789-7.016-.718-.671-1.772-1.94-3.712-1.6a2.064,2.064,0,0,0-1.173,2.538c.5,1.868,2.2,4.286,2.993,5.939a25.657,25.657,0,0,1,1.916,5.1c.359,1.461.287,2.969.742,4.406-1.269-4.191-3.233-9-6.873-11.926-1.03-.838-3.831-2.85-5.891-1.413-1.868,1.317,1.413,3.424,2.035,4.191a33.53,33.53,0,0,1,5.723,9.243c-.694-2.395-3.376-5.388-5.388-6.777-1.173-.79-3.329-2.538-4.837-1.916-3.568,1.485,1.748,5.675,2.634,6.466a18.123,18.123,0,0,1,2.61,2.969,8.91,8.91,0,0,1,1.461,2.3,47.323,47.323,0,0,0-4.67-5.412c-1.844-1.628-3.712-1.149-4.55-.239-2.395,2.634,2.874,5.675,4.31,7.16,2.107,2.179,2.8,4.981,3.927,7.735,1.006,2.49.886,5.292,1.341,7.9.671,4.047,1.772,7.256,5.651,9a26.193,26.193,0,0,0,6.657,2.2c1.006.168,4.215.886,4.215.886a8.3,8.3,0,0,0,2.323-3.3,32.963,32.963,0,0,0,1.868-7.447,30.873,30.873,0,0,0,.671-6.466c-.072-1.078-.144-1.245-.814-1.724-.407-.287-1.293-.527-1.245-.647",
    transform: "translate(-1.361 -55.577)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    "data-name": "Path 3644",
    d: "M112.053,210.765c-.239.048-1.509,3.353-1.988,4a26.257,26.257,0,0,1-8.022,7.639c-3.089,1.772-6.849,2.874-9.651,2.107.958.91,2.155,2.443,3.137,3.233a23.035,23.035,0,0,0,3.64,2.562",
    transform: "translate(-35.838 -79.83)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3645",
    "data-name": "Path 3645",
    d: "M114.248,204.944s4.31,2.706,6.106,3.472c1.916-.934,5.556,2.2,7.208,3.592,1.293,1.1,2.395,1.413,1.868,3.3a21.923,21.923,0,0,1-2.658,5.484,26.68,26.68,0,0,1-3.736,4.478",
    transform: "translate(-44.115 -77.625)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    "data-name": "Path 3646",
    d: "M51.111,195.87c.239-2.347,3.855-1.8,4.741-1.293",
    transform: "translate(-20.203 -73.532)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    "data-name": "Path 3647",
    d: "M95.341,155.554a14.678,14.678,0,0,0,1.533-5.819,9.641,9.641,0,0,0-.359-4.454c-.479-1.1-1.437-1.94-1.748-3.137-.5-2.107.718-4.43.814-6.561a22.725,22.725,0,0,0-1.03-8.884",
    transform: "translate(-36.655 -47.991)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3648",
    "data-name": "Path 3648",
    d: "M72.812,125.107s.479,1.269,1.03,2.778c.407,1.078,1.341,3.089,2.395,3.664,2.969,1.676,5.7-4.789,6.322-6.681.742-2.155,1.533-4.526,2.083-6.633,3.76,2.826,5.316,8.31,9.2,11.087,5.556,4,9.148-.718,12.452-5.1,1.293-1.724,4.047-5.436,4.143-7.352",
    transform: "translate(-28.422 -44.268)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3649",
    "data-name": "Path 3649",
    d: "M46.717,142.846a53.091,53.091,0,0,1,4.909-11.973,121.075,121.075,0,0,1,9.483-14.248c.527-2.586.838-7.615,4.478-9.651,1.6,1.125,4.6,2.682,6.945,2.8a25.339,25.339,0,0,0,9.651-1.317,26.741,26.741,0,0,0,10.273-6.609c1.054-1.2,2.969-3.4,3.855-3.831s2.467,1.341,2.85,1.868a19.283,19.283,0,0,1,3.376,8.836c3.424.287,9.6,2.826,11.973,4.31a70.97,70.97,0,0,1,15.973,13.195,94.213,94.213,0,0,1,14.895,21.049c2.85,5.8,4.263,11.518,6.154,17.6",
    transform: "translate(-18.539 -37.103)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    "data-name": "Path 3650",
    d: "M98.6,151.012v-.455",
    transform: "translate(-38.188 -57.027)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    "data-name": "Path 3651",
    d: "M94.382,71.085s-1.221-7.759-1.557-9.627c-.575-3.209-1.413-6.442-1.844-9.627,3.736-.216,10.01-.575,10.992-5.22.91-4.31-3.472-5.46-6.9-4.646a45.311,45.311,0,0,0-5.268,2.059c.048-1.82-1.126-4.382-1.748-6.083A20.088,20.088,0,0,0,84.588,32.1c-3.017-3.592-8.214-5.1-12.74-4.933a17.2,17.2,0,0,0-5.484,1.1c-1.8.671-3.089,2.251-4.55,3.448-4.861,3.927-8.956,9.459-12.476,14.608-2.035,2.945-9.148,14.584-6.8,14.033s7.256-1.7,9-2.2c1.509-.431,6.561-2.275,7.687-2.371a245.452,245.452,0,0,0,5.053,24.593",
    transform: "translate(-16.778 -10.29)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_263",
    "data-name": "Line 263",
    y1: 1.389,
    transform: "translate(54.328 32.609)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_264",
    "data-name": "Line 264",
    x1: 0.335,
    y1: 1.317,
    transform: "translate(46.976 33.783)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    "data-name": "Path 3652",
    d: "M87.343,43.054a4.722,4.722,0,0,1,2.73.407",
    transform: "translate(-33.925 -16.288)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M71.077,46.905a3.948,3.948,0,0,1,1.485-1.461",
    transform: "translate(-27.765 -17.218)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M103.489,51.312l-.1-.192a.828.828,0,0,0-1.149-.311.866.866,0,0,0-.431.671c-.1.5-.192,1.006-.335,1.509-.6,2.251-1.341,5.053-.12,6.49a2.362,2.362,0,0,0,1.868.79h.311a2.351,2.351,0,0,0,2.035-1.221C106.531,57.131,104.95,53.9,103.489,51.312Z",
    transform: "translate(-38.984 -19.205)",
    fill: "#377dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M81.006,73.594c2.083-.144,2.969-.311,4.526-2.012.79-.862,1.82-2.562,3.808-.814s-1.509,7.328-5.484,8c-1.676.287-4.119-.575-4.6-2.395S79.928,73.379,81.006,73.594Z",
    transform: "translate(-30.821 -26.521)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M83.681,80.583a6.13,6.13,0,0,1,2.538-3.424c.718-.431,4.861-2.371,5.22-1.988",
    transform: "translate(-32.538 -28.457)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    "data-name": "Path 3657",
    d: "M120.8,66.73c.311,2.395.862,4.813,1.365,7.232a.772.772,0,0,0,.91-.623v-.024c.263-2.275.5-4.55.671-6.825C122.716,66.61,121.686,66.682,120.8,66.73Z",
    transform: "translate(-46.597 -25.188)",
    fill: "#132144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    "data-name": "Path 3658",
    d: "M103.8,39.723c-.072-.742-.168-1.509-.287-2.251-.623-3.951-2.347-11.782-7.543-11.518a6.618,6.618,0,0,0-4.334-4.526,17.6,17.6,0,0,0-8.884-1.006c-5.244.934-8.381,4.789-13.745,5.244-.742.072-1.054.934-.335,1.269a11.2,11.2,0,0,0,6.25,1.317,22.332,22.332,0,0,1,7.567.407A23.857,23.857,0,0,0,89.193,29.9a4.772,4.772,0,0,0,3.257-.91c-.838,2.3-.479,3.712.838,5.819,1.844,2.969,3.9,5.891,5.819,9.483.239.455,1.126.455,1.221-.168.168-1.03.263-2.059.335-3.089C101.694,40.609,102.7,40.106,103.8,39.723Z",
    transform: "translate(-26.7 -7.664)",
    fill: "#132144"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_265",
    "data-name": "Line 265",
    x1: 1.628,
    y2: 1.197,
    transform: "translate(77.604 35.435)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    "data-name": "Path 3659",
    d: "M139.225,207.8c1.173-.862,4.071-.766,5.508-.455,2.778.575,4.454,2.9,5.723,5.22-.144-1.437-.551-2.514.886-3.448a5.631,5.631,0,0,1,4-.455c.862.168,4.478,1.054,4.454,2.371-.024,1.58-2.73.623-3.448.12a6.013,6.013,0,0,1-2.059-4.789c-.024-2.059.838-5.7,2.754-6.681-4.741.072-6.9-8.573-5.987-12.117",
    transform: "translate(-53.575 -71.042)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    "data-name": "Path 3660",
    d: "M90.135,72.185a1.179,1.179,0,0,0-.144-.694,2.807,2.807,0,0,0-1.485-.982,1.768,1.768,0,0,0-1.724-.024,8.857,8.857,0,0,0-1.916,1.748,6.468,6.468,0,0,1-2.395,1.293,1.673,1.673,0,0,0-1.126-.144,2.035,2.035,0,0,0-1.628,1.724c-.144.742-.024,2.035.766,2.395a.814.814,0,0,0,.479.072c.192.527.982.814,1.269.168.048-.12.1-.239.144-.383a10.588,10.588,0,0,1,2.706-1.892.579.579,0,0,0,.359-.6c.311-.216.623-.431.934-.623a10.49,10.49,0,0,1,2.682-.671C89.991,73.478,90.4,72.928,90.135,72.185Z",
    transform: "translate(-31.017 -26.621)",
    fill: "#132144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M88.423,215.214a6.28,6.28,0,0,0,2.227-.479",
    transform: "translate(-34.334 -81.333)",
    fill: "none",
    stroke: "#132144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.698
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.f42e2f7eccf17cf4074eef32b2bb0714.svg";
export { ForwardRef as ReactComponent };